import { State } from "@/store/modules/system/index";
import Pusher from "pusher-js";

const setLoader = (state: State, payload): void => {
  state.loader = payload;
};

const setUserPaperPlaneId = (state: State, payload: number): void => {
  state.userPaperPlaneId = payload;
};

const setOpenPaperPlaneModal = (state: State, payload: boolean): void => {
  state.openPaperPlaneModal = payload;
};

const setOpenUserInfoModal = (state: State, payload: boolean): void => {
  state.openUserInfoModal = payload;
};

const setUserInfoId = (state: State, payload: number): void => {
  state.userInfoId = payload;
};

const setWonderPointUrl = (state: State, payload: string): void => {
  state.wonderPointUrl = payload;
};

const setOpenWonderPointModal = (state: State, payload: boolean): void => {
  state.openWonderPointModal = payload;
};

const setDeviceNotification = (state: State, payload): void => {
  state.deviceNotification = payload;
};

const setOpenChangeSpaceModal = (state: State, payload: boolean): void => {
  state.openChangeSpaceModal = payload;
};

const setShowUserTechnicalInfo = (state: State, payload: boolean): void => {
  state.showUserTechnicalInfo = payload;
};

const setPusher = (state: State, payload: Pusher): void => {
  state.pusher = payload;
};

const setSpaceUserTechnicalInfoReceived = (
  state: State,
  payload: any
): void => {
  state.spaceUserTechnicalInfoReceived = payload;
};

const setGraphicClientVersion = (state: State, payload) => {
  state.graphicClientVersion = payload;
};
const setShowWelcome = (state: State, payload: boolean) => {
  state.showWelcome = payload;
};

const setShowCompleteOnBoarding = (state: State, payload: boolean) => {
  state.showCompleteOnBoarding = payload;
};

const setSuggestionsNotifications = (state: State, payload) => {
  state.suggestionsNotifications = payload;
};

const setMaintenanceModal = (state: State, payload) => {
  state.maintenanceModal = payload;
};

const setMaintenanceStart = (state: State, payload) => {
  state.maintenanceStart = payload;
};

const setMaintenaceFinish = (state: State, payload) => {
  state.maintenaceFinish = payload;
};

const setMaintenanceMessageError = (state: State, payload) => {
  state.maintenanceMessageError = payload;
};

const setShowPhotonErrorModal = (state: State, payload: boolean) => {
  state.showPhotonErrorModal = payload;
};

const setShowExitModal = (state: State, payload) => {
  state.showExitModal = payload;
};

const setZoom = (state: State, payload: number) => {
  state.zoom = payload;
};

const setMaxZoom = (state: State, payload: number) => {
  state.maxZoom = payload;
};

const setMinZoom = (state: State, payload: number) => {
  state.minZoom = payload;
};

const setShowCameraOptions = (state: State, payload: boolean) => {
  state.showCameraOptions = payload;
};

const setTutorialModal = (state: State, payload: boolean) => {
  state.showTutorialModal = payload;
};

const setTutorialText = (state: State, payload: number) => {
  state.tutorialText = payload;
};

const setCallTimer = (state: State, payload: any) => {
  state.callTimer = payload;
};

const setNotificationTutorial = (state: State, payload: any) => {
  state.notificationTutorial = payload;
};

const setManageSpaceMenuActive = (state: State, payload) => {
  state.manageSpaceMenuActive = payload;
};

const setConfirmBanModal = (state: State, payload: any) => {
  state.showConfirmBanModal = payload;
};

const setConfirmBanModalData = (state: State, payload: any) => {
  state.confirmModalData = payload;
};

const setDescriptionBoothModal = (state: State, payload: boolean) => {
  state.showDescriptionBooth = payload;
};

const setDescriptionBoothTimeOut = (state: State, payload: boolean) => {
  state.descriptionBoothTimeOut = payload;
};

const setDescriptionBoothModalData = (state: State, payload: any) => {
  state.dataDescriptionBooth = payload;
};

const setDescriptionBoothCountDownModal = (state: State, payload: boolean) => {
  state.descriptionBoothCountDown = payload;
};

const setVacationModal = (state: State, payload: boolean) => {
  state.showVacation = payload;
};

const showGoodMorningModal = (state: State, payload: boolean) => {
  state.showGoodMorningModal = payload;
};

const blockChangeEmoji = (state: State, payload: boolean) => {
  state.blockChangeEmoji = payload;
};

const addReactions = (state: State, payload) => {
  state.reactions = [...state.reactions, ...[payload]];
};

const removeReaction = (state: State, payload) => {
  const index = state.reactions.findIndex(
    (a) =>
      a.room === payload.room &&
      a.emoji === payload.emoji &&
      a.spaceUser === payload.spaceUser
  );
  state.reactions.splice(index, 1);
};

const setShowWebGLContextLostModal = (state: State, payload: boolean) => {
  state.showWebGLContextLostModal = payload;
};

const setShowCloseWebinarModal = (state: State, payload: boolean) => {
  state.showCloseWebinarModal = payload;
};

const setWebinarCloseId = (state: State, payload: number) => {
  state.webinarCloseId = payload;
};

const setShowCallErrorModal = (state: State, payload: boolean) => {
  state.showCallErrorModal = payload;
};

const setSelecSuperSpaceId = (state: State, payload: number) => {
  state.selecSuperSpaceId = payload;
};

const setSelectedPinSuperSpaceId = (state: State, payload: number) => {
  state.selectedPinSuperSpaceId = payload;
};

const setPinCountDownModal = (state: State, payload: boolean) => {
  state.pinCountDown = payload;
};

const setShowPinModal = (state: State, payload: boolean) => {
  state.showPinModal = payload;
};

const setPinTimeOut = (state: State, payload: boolean) => {
  state.pinTimeOut = payload;
};

const setSuperSpaceUserPaperPlaneId = (state: State, payload: number): void => {
  state.superSpaceUserPaperPlaneId = payload;
};

const setShowPinRoomModal = (state: State, payload: boolean) => {
  state.showPinRoomModal = payload;
};

const setIsChangePin = (state: State, payload: boolean) => {
  state.isChangePin = payload;
};

const setManageModalType = (state: State, payload) => {
  state.manageModalType = payload;
};

const setOpenPosterModal = (state: State, payload: boolean) => {
  state.openPosterModal = payload;
};

const setPoster = (state: State, payload) => {
  state.poster = payload;
};

const setErrorGeneralClientGraphic = (state: State, payload: boolean) => {
  state.errorGeneralClientGraphic = payload;
};

const setErrorDataGeneralClientGraphic = (state: State, payload: string) => {
  state.errorDataGeneralClientGraphic = payload;
};

const setShowCallErrorRetryModal = (state: State, payload: boolean) => {
  state.showCallErrorRetryModal = payload;
};

const setShowBirthdayModal = (state: State, payload: boolean) => {
  state.showBirthdayModal = payload;
};

const setDataBirthdayModal = (state: State, payload: any) => {
  state.dataBirthdayModal = payload;
};

const setOpenChangeSpaceFavouriteModal = (state: State, payload: boolean): void => {
  state.openChangeSpaceFavouriteModal = payload;
};

const setOpenNotepadButton = (state: State, payload: boolean): void => {
  state.openNotepadButton = payload;
};

const setOpenNotepadModal = (state: State, payload: boolean): void => {
  state.openNotepadModal = payload;
};

const setCurrentRoom = (state: State, payload: any): void => {
  state.currentRoom = payload;
};

const setShowCompleteOnBoardingTeams = (state: State, payload: boolean) => {
  state.showCompleteOnBoardingTeams = payload;
};

const setWaitingResponseTimeout = (state: State, payload: any) => {
  state.waitingResponseTimeout = payload;
};

const setRobotModal = (state: State, payload: any) => {
  state.showRobotModal = payload;
};

const setEducationModal = (state: State, payload: any) => {
  state.showEducationModal = payload;
};

const setEducationToolModal = (state: State, payload: any) => {
  state.showEducationToolModal = payload;
};

const setEducationBotId = (state: State, payload: any) => {
  state.educationBotId = payload;
};

const setOpenSpotifyModal = (state: State, payload: boolean) => {
  state.openSpotifyModal = payload;
};

const setGameKillerModal = (state: State, payload: boolean) => {
  state.showGameKillerModal = payload;
};

const setGameKillerInfoModal = (state: State, payload: boolean) => {
  state.showGameKillerInfoModal = payload;
};

const setGameKillerVoteAndWinnerModal = (state: State, payload: boolean) => {
  state.showGameKillerVoteAndWinnerModal = payload;
};

const setGameKillerWinner = (state: State, payload: boolean) => {
  state.gamekillerWinner = payload;
};

const setReserveRoomModal = (state: State, payload: boolean) => {
  state.reserveRoomModal = payload;
};

const setCttiGameModal = (state: State, payload: boolean) => {
  state.showCttiGameModal = payload;
};

const setShowAutoVideoEnterModal = (state: State, payload: boolean) => {
  state.showAutoVideoEnterModal = payload;
};

const setAutoVideo = (state: State, payload: boolean) => {
  state.autoVideo = payload;
};

const setReservePhysicalRoomModal = (state: State, payload: boolean) => {
  state.reservePhysicalRoomModal = payload;
};

const setAssistant = (state: State, payload: any) => {
  state.assistant = payload;
};

const setAccessTokenGoogle = (state: State, payload: string) => {
  state.accessTokenGoogle = payload;
};

const setAccessTokenHotmail = (state: State, payload: string) => {
  state.accessTokenHotmail = payload;
};

const setShowModalPlanWarningPremium = (state: State, payload: boolean) => {
  state.showModalPlanWarningPremium = payload;
};

export default {
  setLoader,
  setUserPaperPlaneId,
  setOpenPaperPlaneModal,
  setUserInfoId,
  setOpenUserInfoModal,
  setWonderPointUrl,
  setOpenWonderPointModal,
  setDeviceNotification,
  setOpenChangeSpaceModal,
  setShowUserTechnicalInfo,
  setPusher,
  setSpaceUserTechnicalInfoReceived,
  setGraphicClientVersion,
  setShowWelcome,
  setShowCompleteOnBoarding,
  setSuggestionsNotifications,
  setMaintenanceModal,
  setMaintenanceStart,
  setMaintenaceFinish,
  setMaintenanceMessageError,
  setShowPhotonErrorModal,
  setShowExitModal,
  setZoom,
  setMaxZoom,
  setMinZoom,
  setShowCameraOptions,
  setTutorialModal,
  setTutorialText,
  setCallTimer,
  setNotificationTutorial,
  setManageSpaceMenuActive,
  setConfirmBanModal,
  setConfirmBanModalData,
  setDescriptionBoothModal,
  setDescriptionBoothModalData,
  setVacationModal,
  showGoodMorningModal,
  blockChangeEmoji,
  addReactions,
  removeReaction,
  setDescriptionBoothTimeOut,
  setShowWebGLContextLostModal,
  setShowCloseWebinarModal,
  setWebinarCloseId,
  setDescriptionBoothCountDownModal,
  setShowCallErrorModal,
  setSelecSuperSpaceId,
  setSelectedPinSuperSpaceId,
  setPinCountDownModal,
  setShowPinModal,
  setPinTimeOut,
  setSuperSpaceUserPaperPlaneId,
  setShowPinRoomModal,
  setIsChangePin,
  setManageModalType,
  setOpenPosterModal,
  setPoster,
  setErrorGeneralClientGraphic,
  setErrorDataGeneralClientGraphic,
  setShowCallErrorRetryModal,
  setShowBirthdayModal,
  setDataBirthdayModal,
  setOpenChangeSpaceFavouriteModal,
  setOpenNotepadButton,
  setOpenNotepadModal,
  setCurrentRoom,
  setShowCompleteOnBoardingTeams,
  setWaitingResponseTimeout,
  setRobotModal,
  setEducationModal,
  setEducationToolModal,
  setEducationBotId,
  setOpenSpotifyModal,
  setGameKillerModal,
  setGameKillerInfoModal,
  setGameKillerVoteAndWinnerModal,
  setGameKillerWinner,
  setReserveRoomModal,
  setCttiGameModal,
  setShowAutoVideoEnterModal,
  setAutoVideo,
  setReservePhysicalRoomModal,
  setAssistant,
  setAccessTokenGoogle,
  setAccessTokenHotmail,
  setShowModalPlanWarningPremium,
};
